export default function SectionHead({
  kicker,
  title,
  note,
  accent,
}: {
  kicker: string;
  title: string;
  note?: string;
  accent?: boolean;
}) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className={"h-9 w-1.5 rounded-full " + (accent ? "bg-accent-500" : "bg-primary-500")} />
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-foreground-500">{kicker}</p>
          <h2 className="font-heading mt-1 text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
        </div>
      </div>
      {note && <p className="hidden text-sm text-foreground-500 lg:block">{note}</p>}
    </div>
  );
}